import defaultCodes from "./content/fifa.json"; // FIFA codes are the fallback
import chile from "./content/chile.json";
import new_zealand from "./content/new_zealand.json";
import new_zealand_2020 from "./content/new_zealand_2020.json";
import netherlands from "./content/netherlands.json";
import netherlandsKnvbCup from "./content/netherlands-knvb-cup.json";
import netherlandsKnvbCup2026 from "./content/netherlands-knvb-cup-2026.json";
import belgium_nl from "./content/belgium_nl.json";
import japan from "./content/japan.json";
import portugal from "./content/portugal.json";
import australia from "./content/australia.json";
import australia_capital_football from "./content/australia_capital_football.json";
import australia_south from "./content/australia_south.json";
import norway from "./content/norway.json";
import italy from "./content/italy.json";
import france from "./content/france.json";
import slovakia from "./content/slovakia.json";
import sweden from "./content/sweden.json";
import denmark from "./content/denmark.json";
import denmark_dbu from "./content/denmark_dbu.json";
import denmark_amateur from "./content/denmark_amateur.json";
import us_nisoa from "./content/us_nisoa.json";
import us_ussf from "./content/us_ussf.json";
import us_nfhs from "./content/us_nfhs.json";
import england_fa_c1 from "./content/england_fa_c1.json";
import wales from "./content/wales.json";
import scotland from "./content/scotland.json";
import scotland_19 from "./content/scotland_19.json";
import england from "./content/england.json";
import germany from "./content/germany.json";
import austria from "./content/austria.json";
import austria_18 from "./content/austria_18.json";
import { MisconductCodes } from "refsix-js-models";

export const defaultMisconductCodes = defaultCodes;

export function getMisconductByLocale(
    locale: string | undefined,
    nationalFA: String | undefined = undefined
): string {
    if (!locale) {
        return "fifa";
    }
    const loc = locale;
    switch (true) {
        case loc.includes("en-US"):
            return "us_ussf";
        case loc.includes("en-GB"):
            switch (nationalFA) {
                case "NIR":
                    return "fifa";
                case "SCO":
                    return "scotland_19";
                case "WAL":
                    return "wales";
                case "ENG":
                default:
                    return "england";
            }
        case loc.includes("at"):
            return "austria_18";
        case loc.includes("nl-BE"):
            return "belgium_nl";
        case loc.includes("cl"):
            return "chile";
        case loc.includes("dk"):
            return "denmark_amateur";
        case loc.includes("fr"):
            return "france";
        case loc.includes("de"):
            return "germany";
        case loc.includes("it"):
            return "italy";
        case loc.includes("ja"):
            return "japan";
        case loc.includes("nl"):
            return "netherlands";
        case loc.includes("nz"):
            return "new_zealand_2020";
        case loc.includes("nb"):
        case loc.includes("no"):
            return "norway";
        case loc.includes("pt"):
            return "portugal";
        case loc.includes("sk"):
            return "slovakia";
        case loc.includes("se"):
            return "sweden";
        default:
            return "fifa";
    }
}

const misconductCodesByCountry: MisconductCodes[] = [
    // MAKE SURE THIS IS RELEASED AND TESTED PROPERLY!!
    // https://refsix.atlassian.net/wiki/spaces/REF/pages/716079109/Misconduct+Codes

    // ORDER IS IMPORTANT!!!
    // if multiple matches, the most recently required one will be selected.

    chile,
    new_zealand,
    new_zealand_2020,
    netherlandsKnvbCup,
    netherlandsKnvbCup2026,
    netherlands,
    belgium_nl,
    japan,
    portugal,
    australia,
    australia_capital_football,
    australia_south,
    norway,
    italy,
    france,
    slovakia,
    sweden,
    denmark,
    denmark_dbu,
    denmark_amateur,

    us_nisoa,
    us_ussf,
    us_nfhs,
    defaultCodes,
    england_fa_c1,
    wales,
    scotland,
    scotland_19,
    england,

    germany,
    austria,
    austria_18,
] as unknown as MisconductCodes[]; // needed due to jsons containing strings instead of enums for ReasonType

export function getPreSetCodes() {
    return misconductCodesByCountry;
}

export function findNameById(id: string) {
    let misconductName = "Custom";
    misconductCodesByCountry.forEach(function (code) {
        if (id === code.id) {
            misconductName = code.name;
        }
    });

    return misconductName;
}

export function getPreSetCodesById(id: string) {
    for (let i = 0; i < misconductCodesByCountry.length; i++) {
        if (misconductCodesByCountry[i].id === id) {
            return misconductCodesByCountry[i];
        }
    }
}

// Resolve a preset misconduct code by its NAME (case-insensitive) — the inverse
// of findNameById. Names are what the xlsx upload template and the
// SoccerRefManager integration send (e.g. "Deutschland", "US NFHS").
export function findPresetCodeByName(
    name: string | undefined
): MisconductCodes | undefined {
    if (!name) {
        return undefined;
    }
    const target = name.toLowerCase();
    let match: MisconductCodes | undefined;
    misconductCodesByCountry.forEach(function (code) {
        if (code.name && code.name.toLowerCase() === target) {
            match = code;
        }
    });
    return match;
}

// Resolve a preset misconduct code NAME to its id, defaulting to "fifa" for an
// unknown/absent name.
export function findIdByName(name: string | undefined): string {
    const code = findPresetCodeByName(name);
    return code ? code.id : "fifa";
}

export function findCodeByLocale(locale: string) {
    let misconductCode = "fifa";
    misconductCodesByCountry.forEach(function (code) {
        if (code.locale && locale.indexOf(code.locale) !== -1) {
            misconductCode = code.id;
        }
    });

    return misconductCode;
}
